import React from 'react';

import { useNavigate } from 'react-router-dom';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';

import InviteEmailCompleteForm from './InviteEmailCompleteForm';

const InviteEmailCompletePage: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToMypage = () => {
    navigate('/mypage/profile');
  };

  return (
    <SingleColumnTemplate>
      <InviteEmailCompleteForm onNavigateToMypage={handleNavigateToMypage} />
    </SingleColumnTemplate>
  );
};

export default InviteEmailCompletePage;
